"use strict";

customElements.define('ec-cpm-fabric', class extends HTMLElement {
  constructor() {
    super();
    this.startContainerEl = null;
    this.groupContainerElements = null;
    this.colourSelectEl = null;
    this.fabricTypeSelectEl = null;
    this.availabilityCheckboxEl = null;
    this.emptyMessageEl = null;
    this.resetEl = null;
    this.selectedColour = '';
    this.selectedFabricType = '';
    this.availableNowOnly = false;
    this.groupVisibilityMap = new Map();
    this.handleColourChange = this.handleColourChange.bind(this);
    this.handleFabricTypeChange = this.handleFabricTypeChange.bind(this);
    this.handleAvailabilityChange = this.handleAvailabilityChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleAvailabilityUpdate = this.handleAvailabilityUpdate.bind(this);
  }
  toHandle(str) {
    if (!str) return '';
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  connectedCallback() {
    this.startContainerEl = this.querySelector('.ec-cpm__grid.ec-cpm__grid--6.hide');
    this.groupContainerElements = this.querySelectorAll('.ec-cpm__fabric-group');
    this.colourSelectEl = this.querySelector('.ec-cpm__filter .ec-cpm__filter-colour select');
    this.filterContainerEl = this.querySelector('.ec-cpm__filter');
    this.fabricTypeSelectEl = this.querySelector('.ec-cpm__filter .ec-cpm__filter-fabric select');
    this.availabilityCheckboxEl = this.querySelector('.ec-cpm__filter input[name="filter-available"]');
    this.emptyMessageEl = this.querySelector('.ec-cpm__filter-empty');
    this.resetEl = this.querySelector('[id^="Reset-"]');
    if (this.groupContainerElements.length < 1) {
      this.startContainerEl?.classList.remove('hide');
      this.filterContainerEl?.classList.add('hide');
      this.emptyMessageEl?.classList.add('hide');
      return;
    }
    this.groupVisibilityMap.clear();
    this.groupContainerElements.forEach(group => {
      const rawType = group.getAttribute('data-group-type');
      const fabricType = this.toHandle(rawType);
      if (fabricType) {
        this.groupVisibilityMap.set(fabricType, {
          visibleByType: true,
          visibleByColor: true,
          visibleByAvailability: true
        });
      }
    });
    this.colourSelectEl?.addEventListener('change', this.handleColourChange);
    this.fabricTypeSelectEl?.addEventListener('change', this.handleFabricTypeChange);
    this.availabilityCheckboxEl?.addEventListener('change', this.handleAvailabilityChange);
    this.resetEl?.addEventListener('click', this.handleReset);
    document.addEventListener('ec-cpm:availability-changed', this.handleAvailabilityUpdate);
    this.init();
    this.expandAccordion();
  }
  disconnectedCallback() {
    this.colourSelectEl?.removeEventListener('change', this.handleColourChange);
    this.fabricTypeSelectEl?.removeEventListener('change', this.handleFabricTypeChange);
    this.availabilityCheckboxEl?.removeEventListener('change', this.handleAvailabilityChange);
    this.resetEl?.removeEventListener('click', this.handleReset);
    document.removeEventListener('ec-cpm:availability-changed', this.handleAvailabilityUpdate);
  }
  handleColourChange(e) {
    this.selectedColour = this.toHandle(e.target.value);
    this.applyFilters();
  }
  expandAccordion() {
    document.querySelectorAll('.ec-cpm-accordion').forEach(e => {
      if (e.querySelector('summary div').innerHTML.indexOf(".") != -1) {
        e.setAttribute("open", "");
      }
    });
  }
  handleFabricTypeChange(e) {
    this.selectedFabricType = this.toHandle(e.target.value);
    this.groupVisibilityMap.forEach((groupState, fabricTypeHandle) => {
      groupState.visibleByType = !this.selectedFabricType || fabricTypeHandle === this.selectedFabricType;
    });
    this.applyFilters();
  }
  handleAvailabilityChange(e) {
    this.availableNowOnly = e.target.checked;
    this.applyFilters();
  }
  handleAvailabilityUpdate() {
    this.applyFilters();
  }
  handleReset(e) {
    e?.preventDefault();
    if (this.fabricTypeSelectEl) this.fabricTypeSelectEl.value = '';
    this.selectedFabricType = '';
    if (this.colourSelectEl) this.colourSelectEl.value = '';
    this.selectedColour = '';
    if (this.availabilityCheckboxEl) this.availabilityCheckboxEl.checked = false;
    this.availableNowOnly = false;
    this.groupVisibilityMap.forEach(state => {
      state.visibleByType = true;
      state.visibleByColor = true;
      state.visibleByAvailability = true;
    });
    this.querySelectorAll('input[data-fabric-colour]').forEach(input => {
      const parent = input.parentElement;
      if (parent) parent.classList.remove('hide');
    });
    this.updateGroupVisibility();
    this.emptyMessageEl?.classList.add('hide');
    this.resetEl?.classList.add('hide');
    this.dispatchPriceUpdateEvent();
  }
  applyFilters() {
    let totalVisibleItems = 0;
    const noColorSelected = !this.selectedColour || this.selectedColour === '';
    this.groupContainerElements.forEach(group => {
      const rawGroupType = group.getAttribute('data-group-type');
      const fabricTypeHandle = this.toHandle(rawGroupType);
      const groupState = this.groupVisibilityMap.get(fabricTypeHandle);
      if (!groupState) return;
      let groupHasVisibleItems = false;
      const inputs = group.querySelectorAll('input[data-fabric-colour]');
      inputs.forEach(input => {
        const wrapper = input.parentElement;
        const rawColor = input.getAttribute('data-fabric-colour');
        const rawAvail = input.getAttribute('data-available-now');
        const itemColorHandle = this.toHandle(rawColor);
        const itemAvailable = rawAvail === 'true';
        const isVisibleByColor = noColorSelected || itemColorHandle === this.selectedColour;
        const isVisibleByAvailability = !this.availableNowOnly || itemAvailable;
        const isVisible = isVisibleByColor && isVisibleByAvailability;
        if (wrapper) {
          wrapper.classList.toggle('hide', !isVisible);
        }
        if (isVisible) {
          groupHasVisibleItems = true;
        }
      });
      groupState.visibleByColor = groupHasVisibleItems || noColorSelected;
      groupState.visibleByAvailability = groupHasVisibleItems || !this.availableNowOnly;
      const finalGroupVisible = groupState.visibleByType && groupState.visibleByColor && groupState.visibleByAvailability;
      if (finalGroupVisible) {
        const visibleWrappers = Array.from(inputs).filter(input => {
          return input.parentElement && !input.parentElement.classList.contains('hide');
        });
        totalVisibleItems += visibleWrappers.length;
      }
    });
    this.updateGroupVisibility();
    const showEmpty = totalVisibleItems === 0;
    this.emptyMessageEl?.classList.toggle('hide', !showEmpty);
    this.resetEl?.classList.toggle('hide', !showEmpty);
    this.dispatchPriceUpdateEvent();
  }
  updateGroupVisibility() {
    this.groupContainerElements.forEach(group => {
      const typeHandle = this.toHandle(group.getAttribute('data-group-type'));
      const state = this.groupVisibilityMap.get(typeHandle);
      const shouldHide = !(state?.visibleByType && state?.visibleByColor && state?.visibleByAvailability);
      group.classList.toggle('hide', shouldHide);
    });
  }
  dispatchPriceUpdateEvent() {
    const event = new CustomEvent('ec-cpm:update-prices', {
      bubbles: true,
      composed: true
    });
    document.dispatchEvent(event);
  }
  init() {
    if (this.startContainerEl) {
      const children = Array.from(this.startContainerEl.children);
      children.forEach(child => {
        let type = child.getAttribute('data-container-type');
        if (!type) {
          const innerInput = child.querySelector('input[data-fabric-type]');
          if (innerInput) {
            type = innerInput.getAttribute('data-fabric-type');
          }
        }
        if (!type) {
          return;
        }
        const typeHandle = this.toHandle(type);
        let targetGrid = null;
        const potentialGroups = this.querySelectorAll('.ec-cpm__fabric-group');
        for (const group of potentialGroups) {
          if (this.toHandle(group.getAttribute('data-group-type')) === typeHandle) {
            targetGrid = group.querySelector('.ec-cpm__grid');
            break;
          }
        }
        if (targetGrid) {
          targetGrid.appendChild(child);
        }
      });
      if (this.startContainerEl.children.length === 0) {
        this.startContainerEl.remove();
        this.startContainerEl = null;
      } else {
        this.startContainerEl.classList.add('hide');
      }
    }
    this.emptyMessageEl?.classList.add('hide');
    this.resetEl?.classList.add('hide');
    this.applyFilters();
  }
});